var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaste(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_4",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 99.21 99.21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M65.12,98.08H2.35c-.55,0-1-.45-1-1V17.07c0-.55.45-1,1-1h47.14c.26,0,.51.1.69.28l15.63,15.05c.2.19.31.45.31.72v64.96c0,.55-.45,1-1,1ZM3.35,96.08h60.77v-63.54s-15.03-14.47-15.03-14.47H3.35v78.01Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M65.12,33.12h-15.31c-.55,0-1-.45-1-1v-14.48c0-.55.45-1,1-1s1,.45,1,1v13.48h14.31c.55,0,1,.45,1,1s-.45,1-1,1Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M97.76,84.05h-32.64c-.55,0-1-.45-1-1s.45-1,1-1h31.64V18.51s-15.03-14.47-15.03-14.47h-45.74s0,12.67,0,12.67c0,.55-.45,1-1,1s-1-.45-1-1V3.04c0-.27.11-.52.29-.71s.44-.29.71-.29h47.14c.26,0,.51.1.69.28l15.63,15.05c.2.19.31.45.31.72v64.96c0,.55-.45,1-1,1Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M97.76,19.08h-15.31c-.55,0-1-.45-1-1V3.61c0-.55.45-1,1-1s1,.45,1,1v13.48h14.31c.55,0,1,.45,1,1s-.45,1-1,1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaste);
export default __webpack_public_path__ + "static/media/Paste.7a5e817595fe384f4f9ad3641be1e6de.svg";
export { ForwardRef as ReactComponent };